<template>
  <transition name="fade">
    <div class="modal" v-if="show" v-on:click="modalClicked">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <h4>{{title}}</h4>
        <div class="close" v-on:click="close(false)"></div>
        <div class="formCnt" v-if="section === 0">
          <div class="fieldGroup">
            <label>Photos</label>
            <div class="priceOk">
              <div class="priceNav p" v-if="photoIdx > 0"
                v-on:click="photoIdx -= 1"></div>
              <div class="priceNav n" v-if="images.length > 3 && photoIdx < images.length - 3"
                v-on:click="photoIdx += 1"></div>
              <div class="priceSc">
                <div class="prizeCnt" :style="{width: `${(images.length + 1) * 130}px`}"
                  :class="[`prize${photoIdx}`]">
                  <div class="prizeItem" v-for="(item, i) in images" :key="i">
                    <div class="catImg hasImg" v-on:click.stop="editImg(i, item)"
                      v-if="item.media.imageMd"
                      :style="{'background-image': `url(${item.media.imageMd})`}">
                      <div class="more" v-on:click.stop="showImgMore = i"></div>
                      <div class="moreMenu" v-if="showImgMore === i"
                        v-on:click.stop="doNothing">
                        <li v-on:click.stop="editImg(i, item)">Edit image</li>
                        <li class="red" v-on:click.stop="deleteImg(i, item)">Hapus</li>
                      </div>
                    </div>
                    <div class="catImg" v-on:click.stop="editImg(i, item)" v-else>
                      <div class="more" v-on:click.stop="showImgMore = i"></div>
                      <div class="moreMenu" v-if="showImgMore === i"
                        v-on:click.stop="doNothing">
                        <li v-on:click.stop="editImg(i, item)">Edit image</li>
                        <li class="red" v-on:click.stop="deleteImg(i, item)">Hapus</li>
                      </div>
                    </div>
                  </div>
                  <div class="catImg addPrize" v-on:click="addImg">
                    <span><img src="../assets/photo-black.png"></span>
                    Add Photo
                  </div>
                </div>
              </div>
            </div>
          </div>
          <form v-on:submit.prevent="handleSubmit">
            <div class="fieldGroup fg2a">
              <div class="fieldCnt fc1" :class="{hasError: form.name.error}">
                <label>Name</label>
                <input type="text" class="field" placeholder="Product name..."
                  v-model="form.name.model" v-on:input="fieldChanged('name')">
                <div class="fieldError">Please input product name</div>
              </div>
              <div class="fieldCnt fc2">
                <label>Category</label>
                <select class="field" v-model="form.category.model">
                  <option v-for="(c, i) in categories" :key="`c${i}`"
                    :value="c.id">{{c.name}}</option>
                </select>
              </div>
            </div>
            <div class="fieldGroup fg2a">
              <div class="fieldCnt fc1">
                <label>Warehouse</label>
                <select class="field" v-model="form.warehouse.model">
                  <option v-for="(e, i) in warehouse" :key="`e${i}`"
                    :value="e.id">{{e.name}}</option>
                </select>
              </div>
              <div class="fieldCnt fc2">
                <label>Product edition</label>
                <select class="field" v-model="form.edition.model">
                  <option v-for="(e, i) in editions" :key="`e${i}`"
                    :value="e.id">{{e.name}}</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div class="formCnt" v-if="section === 1">
          <form v-on:submit.prevent="handleSubmit">
            <div class="fieldGroup fg2c" v-for="(item, i) in info" :key="`info${i}`">
              <div class="deleteVariant" v-on:click="deleteInfo(i)"></div>
              <div class="fieldCnt fc1">
                <label>Label</label>
                <input type="text" class="field" placeholder="Label"
                  v-model="item.label">
              </div>
              <div class="fieldCnt fc2">
                <label>Information</label>
                <input type="text" class="field" placeholder="Information..."
                  v-model="item.info">
              </div>
            </div>
            <div class="addVariant" v-on:click="addInfo">Add Info</div>
          </form>
        </div>
        <div class="formCnt" v-else-if="section === 2">
          <div class="tabCnt">
            <div class="tab tab1" v-for="(tab, i) in tabs" :key="`tab${i}`"
              :class="{active: tabActive === i}" v-on:click="selectTab(i, tab)">{{tab.title}}
              <div class="deleteVariant deleteTab" v-on:click="deleteTab(i)"
                v-if="i >= 1"></div>
            </div>
            <div class="tab addTab" v-on:click="addTab">Add Tab</div>
          </div>
          <Editor v-model="tabs[tabActive].model" :content="tabs[tabActive].content"/>
        </div>
        <div class="formCnt" v-else-if="section === 3">
          <form v-on:submit.prevent="handleSubmit">
            <div class="fieldGroup">
              <div class="twoOptions">
                <div class="option" :class="{selected: variantType === 'single'}"
                  v-on:click="variantType = 'single'">
                  Single Variant
                </div>
                <div class="option" :class="{selected: variantType === 'multiple'}"
                  v-on:click="variantType = 'multiple'">
                  Multiple Variant
                </div>
              </div>
              <div class="fieldHint">You can add variant like color, size, etc</div>
            </div>
            <div class="variantCnt" v-if="variantType === 'multiple'">
              <div class="variantMaster" v-for="(vm, im) in variantMaster" :key="`vm${im}`">
                <h4>{{vm.name}}</h4>
                <div class="variantItem" v-for="(v, i) in vm.variants" :key="`v${i}`">
                  <div class="deleteVariant" v-on:click="deleteVariant(i, v, im, vm)"></div>
                  <h5>{{vm.name}}: {{v.variantItem.name}}</h5>
                  <div class="fieldGroup fg2b">
                    <div class="fieldCnt fc1">
                      <label>In Stock</label>
                      <input type="number" class="field" placeholder="In stock..."
                        v-model="v.inStock.model" v-on:input="fieldChangedV(i, 'inStock')">
                    </div>
                    <div class="fieldCnt fc2">
                      <label>Aditional Price</label>
                      <input type="number" class="field hasPrefix" placeholder="Aditional price..."
                        v-model="v.sellPrice.model" v-on:input="fieldChangedV(i, 'sellPrice')">
                        <div class="fieldPrefix">Rp</div>
                      <div class="fieldError" v-if="v.sellPrice.error">{{v.sellPrice.error}}</div>
                    </div>
                  </div>
                  <div class="fieldGroup">
                    <label>Photos</label>
                    <div class="priceOk">
                      <div class="priceNav p" v-if="v.photoIdx > 0"
                        v-on:click="v.photoIdx -= 1"></div>
                      <div class="priceNav n" v-if="v.images.length > 3
                        && v.photoIdx < v.images.length - 3"
                        v-on:click="v.photoIdx += 1"></div>
                      <div class="priceSc">
                        <div class="prizeCnt" :style="{width: `${(v.images.length + 1) * 130}px`}"
                          :class="[`prize${v.photoIdx}`]">
                          <div class="prizeItem" v-for="(img, i2) in v.images" :key="`vimg${i2}`">
                            <div class="catImg hasImg" v-if="img.media"
                              v-on:click.stop="editImgV(i, v, i2, img, im, vm)"
                              :style="{'background-image': `url(${img.media.imageMd})`}">
                              <div class="more" v-on:click.stop="v.showImgMore = i2"></div>
                              <div class="moreMenu" v-if="v.showImgMore === i2"
                                v-on:click.stop="doNothing">
                                <li v-on:click.stop="editImgV(i, v, i2, img, im, vm)">Edit</li>
                                <li class="red" v-on:click.stop="deleteImgV(i, v, i2, img, im, vm)">
                                  Hapus</li>
                              </div>
                            </div>
                            <div class="catImg" v-else
                              v-on:click.stop="editImgV(i, v, i2, img, im, vm)">
                              <div class="more" v-on:click.stop="v.showImgMore = i2"></div>
                              <div class="moreMenu" v-if="v.showImgMore === i2"
                                v-on:click.stop="doNothing">
                                <li v-on:click.stop="editImgV(i, v, i2, img, im, vm)">Edit</li>
                                <li class="red" v-on:click.stop="deleteImgV(i, v, i2, img, im, vm)">
                                  Hapus</li>
                              </div>
                            </div>
                          </div>
                          <div class="catImg addPrize" v-on:click="addImgV(i, v, im, vm)">
                            <span><img src="../assets/photo-black.png"></span>
                            Add Photo
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="addVariantCnt">
                  <div class="addVariant" v-on:click="addVariant(vm)">Add variant item</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="fieldGroup" :class="{fg3b: !hasVariant, fg2c: hasVariant}">
                <div class="fieldCnt fc1" :class="{hasError: form.minPurchase.error}">
                  <label>Purchase Minimum</label>
                  <input type="number" class="field" placeholder="Purchase minimum..."
                    v-model="form.minPurchase.model" v-on:input="fieldChanged('minPurchase')">
                  <div class="fieldError">{{form.minPurchase.error}}</div>
                </div>
                <div class="fieldCnt fc2" :class="{hasError: form.inStock.error}"
                  v-if="!hasVariant">
                  <label>In Stock</label>
                  <input type="number" class="field" placeholder="In stock..."
                    v-model="form.inStock.model" v-on:input="fieldChanged('inStock')">
                  <div class="fieldError">{{form.inStock.error}}</div>
                </div>
                <div class="fieldCnt fc3 fieldSku" :class="{hasError: form.sku.error,
                  fc3: !hasVariant, fc2: hasVariant}">
                  <label>SKU</label>
                  <input type="text" class="field" placeholder="Input SKU..."
                    v-model="form.sku.model" v-on:input="fieldChanged('sku')"
                    :disabled="form.sku.auto"
                    :class="{disabled: form.sku.auto}">
                  <div class="fieldError">{{form.sku.error}}</div>
                  <div class="toggle">
                    <div class="radioItem" :class="{on: form.sku.auto}"
                      v-on:click="form.sku.auto = !form.sku.auto">
                      <div class="radioIn">
                        <div class="radioHandle"></div>
                      </div>
                      Auto
                    </div>
                  </div>
                </div>
              </div>
              <div class="fieldGroup fg3b">
                <div class="fieldCnt fc1" :class="{hasError: form.sellPrice.error}">
                  <label>Base Price</label>
                  <input type="number" class="field hasPrefix" placeholder="Input price..."
                    v-model="form.sellPrice.model" v-on:input="fieldChanged('sellPrice')">
                    <div class="fieldPrefix">Rp</div>
                  <div class="fieldError">{{form.sellPrice.error}}</div>
                </div>
                <div class="fieldCnt fc2">
                  <label>Discount</label>
                  <input type="number" class="field" placeholder="Discount..."
                    :class="{hasSuffix: form.discountType.model === 'percentage',
                    hasPrefix: form.discountType.model === 'fixed'}"
                    v-model="form.discount.model" v-on:input="discountChanged">
                  <div class="fieldSuffix" v-if="form.discountType.model === 'percentage'">%</div>
                  <div class="fieldPrefix" v-else>Rp</div>
                </div>
                <div class="fieldCnt fc3">
                  <label>Discount</label>
                  <select class="field" v-model="form.discountType.model"
                    v-on:change="discountChanged">
                    <option value="percentage">Percentage</option>
                    <option value="fixed">Fixed Price</option>
                  </select>
                </div>
              </div>
              <div class="fieldGroup" v-if="form.discountedPrice.model
                && form.discountedPrice.model !== ''">
                <div class="fieldCnt">
                  <label>Publish Price</label>
                  <input type="number" class="field hasPrefix disabled"
                    placeholder="Discounted price..."
                    v-model="form.discountedPrice.model" readonly>
                    <div class="fieldPrefix">Rp</div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="formCnt" v-else-if="section === 4">
          <div class="fieldGroup fg4">
            <div class="fieldCnt" :class="{hasError: form.weight.error}">
              <label>Weight</label>
              <input type="number" class="field hasSuffix" placeholder="Weight..."
                v-model="form.weight.model" v-on:input="fieldChanged('weight')">
              <div class="fieldSuffix">Gr</div>
              <div class="fieldError">Weight required</div>
            </div>
            <div class="fieldCnt" :class="{hasError: form.length.error}">
              <label>Length</label>
              <input type="number" class="field hasSuffix" placeholder="Length..."
                v-model="form.length.model" v-on:input="fieldChanged('length')">
              <div class="fieldSuffix">Cm</div>
              <div class="fieldError">Length required</div>
            </div>
            <div class="fieldCnt fc2" :class="{hasError: form.width.error}">
              <label>Width</label>
              <input type="number" class="field hasSuffix" placeholder="Width..."
                v-model="form.width.model" v-on:input="fieldChanged('width')">
              <div class="fieldSuffix">Cm</div>
              <div class="fieldError">Width required</div>
            </div>
            <div class="fieldCnt" :class="{hasError: form.height.error}">
              <label>Height</label>
              <input type="number" class="field hasSuffix" placeholder="Height..."
                v-model="form.height.model" v-on:input="fieldChanged('height')">
              <div class="fieldSuffix">Cm</div>
              <div class="fieldError">Height required</div>
            </div>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt">
              <div class="toggle">
                <div class="radioItem" :class="{on: preOrder}"
                  v-on:click="preOrder = !preOrder">
                  <div class="radioIn">
                    <div class="radioHandle"></div>
                  </div>
                  Pre Order
                </div>
              </div>
            </div>
          </div>
          <div class="fieldGroup" v-if="preOrder">
            <div class="fieldCnt">
              <label>Pre Order Processing Time</label>
              <input type="number" class="field hasSuffix" placeholder="Processing time..."
                v-model="form.preOrderDays.model">
              <div class="fieldSuffix">Days</div>
            </div>
          </div>
        </div>
        <div class="modalAction">
          <button class="btn btnSecondary" type="button"
            v-on:click="cancel" v-if="!loading">
            <span v-if="section === 0">Cancel</span>
            <span v-else>Previous</span>
          </button>
          <button class="btn btnPrimary" type="submit" v-on:click="handleSubmit"
            :class="{btnLoading: loading}">
            <span v-if="section === 4">Save</span>
            <span v-else>Next</span>
          </button>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
      <FormInputerShort ref="formInputer"/>
      <MediaSelector ref="mediaSelector"/>
      <Snackbar ref="snackbar"/>
      <VariantSelector ref="variantSelector"/>
    </div>
  </transition>
</template>

<script>
import HugeUploader from 'huge-uploader';

import Confirmation from '@/components/Confirmation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import MediaSelector from '@/components/MediaSelector.vue';
import Snackbar from '@/components/Snackbar.vue';
import VariantSelector from '@/components/VariantSelector.vue';
import Editor from '@/components/Editor.vue';

export default {
  name: 'addUndian',
  components: {
    Confirmation,
    FormInputerShort,
    MediaSelector,
    VariantSelector,
    Snackbar,
    Editor,
  },
  data() {
    return {
      show: false,
      loading: false,
      section: 0,
      next: null,
      title: '',

      categories: [],
      editions: [],
      warehouse: [],

      /**
       * Form
       *
       */
      form: {
        name: { model: '', error: null },
        warehouse: { model: '' },
        category: { model: '' },
        edition: { model: '' },
        minPurchase: { model: '' },
        inStock: { model: '' },
        sku: { model: '', error: null, auto: true },
        sellPrice: { model: '', error: null },
        discountedPrice: { model: '' },
        discount: { model: '' },
        weight: { model: '', error: null },
        height: { model: '', error: null },
        width: { model: '', error: null },
        length: { model: '', error: null },
        preOrderDays: { model: '' },
        discountType: { model: 'percentage' },
      },
      info: [],
      tabActive: 0,
      tabs: [],
      preOrder: false,
      variantType: 'single',
      hasVariant: false,

      /**
       * Product images
       *
       */
      photoIdx: 0,
      showImgMore: false,
      images: [],
      variantMaster: [],

      d: null,
    };
  },
  methods: {
    modalClicked() {
      this.showImgMore = null;
      if (this.variantMaster && this.variantMaster.length > 0) {
        // eslint-disable-next-line
        for (const vm of this.variantMaster) {
          // eslint-disable-next-line
          for (const v of vm.variants) {
            v.showImgMore = null;
          }
        }
      }
    },
    open(d, n) {
      this.d = d;
      this.title = 'Product Data';
      this.loading = false;
      this.section = 0;
      this.next = n;
      this.show = true;
      this.images = (d && d.images) ? d.images : [];
      this.form.name.model = (d && d.name) ? d.name : '';
      this.form.name.error = null;
      this.form.minPurchase.model = (d && d.purchaseMinimum) ? d.purchaseMinimum : '';
      this.form.inStock.model = (d && d.inStock) ? d.inStock : '';
      this.form.sku.model = (d && d.sku) ? d.sku : '';
      this.form.sku.error = null;
      this.form.sellPrice.model = (d && d.sellPrice) ? d.sellPrice : '';
      this.form.discount.model = (d && d.discount) ? d.discount : '';
      this.form.discountType.model = (d && d.discountType) ? d.discountType : 'percentage';
      this.form.weight.model = (d && d.weight) ? d.weight : '';
      this.form.weight.error = null;
      this.form.height.model = (d && d.height) ? d.height : '';
      this.form.height.error = null;
      this.form.width.model = (d && d.width) ? d.width : '';
      this.form.width.error = null;
      this.form.length.model = (d && d.length) ? d.length : '';
      this.form.length.error = null;
      this.form.preOrderDays.model = (d && d.preOrderDays) ? d.preOrderDays : '';
      this.form.edition.model = (d && d.editionId) ? d.editionId : '';
      this.form.category.model = (d && d.categoryId) ? d.categoryId : '';
      this.preOrder = (d && d.isPreOrder);
      this.variantType = 'single';
      this.variantMaster = (d && d.variants) ? d.variants : [];

      // eslint-disable-next-line
      for (const vm of this.variantMaster) {
        this.hasVariant = vm.variants.length > 0;
      }

      if (d && d.info && d.info.length > 0) {
        this.info = d.info;
      } else {
        this.info = [{ label: '', info: '' }, { label: '', info: '' }, { label: '', info: '' }];
      }
      this.tabActive = 0;
      if (d && d.tabs && d.tabs.length > 0) {
        this.tabs = d.tabs;
      } else {
        this.tabs = [
          { title: 'Deskripsi Produk', model: '', content: '' },
          { title: 'Informasi Ukuran', model: '', content: '' },
        ];
      }
      if (this.editions.length < 1) this.getEdition();
      if (this.categories.length < 1) this.getCategories();
      if (this.warehouse.length < 1) this.getWarehouse();
      if (this.variantMaster.length < 1) this.getVariantMaster();
      this.discountChanged();
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    discountChanged() {
      if (this.form.discount.model && this.form.sellPrice.model) {
        const sellPrice = parseInt(this.form.sellPrice.model, 10);
        const discountValue = parseInt(this.form.discount.model, 10);
        if (this.form.discountType.model === 'percentage') {
          this.form.discountedPrice.model = (sellPrice - (sellPrice
            * discountValue / 100)).toLocaleString('id');
        } else {
          this.form.discountedPrice.model = (sellPrice
            - discountValue).toLocaleString('id');
        }
      } else {
        this.form.discountedPrice.model = '';
      }
    },
    deleteInfo(i) { this.info.splice(i, 1); },
    addInfo() { this.info.push({ label: '', info: '' }); },
    getVariantMaster() {
      this.$http.get(this.$config.uri('product/variant/all')).then((r) => {
        if (r.data.status !== 200) return;
        this.variantMaster = r.data.data;
      });
    },
    getEdition() {
      this.$http.get(this.$config.uri('product/edition/all')).then((r) => {
        if (r.data.status !== 200) return;
        this.editions = r.data.data;
        this.form.edition.model = this.editions[0].id;
        if (this.d && this.d.editionId) this.form.edition.model = this.d.editionId;
      });
    },
    deleteVariant(i, v, im, vm) {
      vm.variants.splice(i, 1);
      // eslint-disable-next-line
      for (const vm of this.variantMaster) {
        this.hasVariant = vm.variants.length > 0;
      }
    },
    addVariant(vm) {
      this.$refs.variantSelector.open(vm, (b, v) => {
        if (!b) return;
        vm.variants.push({
          variantItem: v,
          images: [],
          isPrimary: false,
          photoIdx: 0,
          minPurchase: { model: '' },
          inStock: { model: '' },
          sku: { model: '', error: null, auto: true },
          sellPrice: { model: '', error: null },
          discount: { model: '' },
        });
        this.hasVariant = true;
      });
    },
    getWarehouse() {
      this.$http.get(this.$config.uri('product/warehouse/all')).then((r) => {
        if (r.data.status !== 200) return;
        this.warehouse = r.data.data;
        this.form.warehouse.model = this.warehouse[0].id;
        if (this.d && this.d.warehouseId) this.form.warehouse.model = this.d.warehouseId;
      });
    },
    getCategories() {
      this.$http.get(this.$config.uri('product/category/all')).then((r) => {
        if (r.data.status !== 200) return;
        this.categories = r.data.data;
        this.form.category.model = this.categories[0].id;
        if (this.d && this.d.categoryId) this.form.category.model = this.d.categoryId;
      });
    },
    addImgV(i, item, im, vm) {
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        const m = (media.gallery) ? media.gallery : [media];
        const data = [];
        for (const item of m) { // eslint-disable-line
          data.push({ media: item });
        }
        vm.variants[i].images.push(...data);
      });
    },
    editImgV(i, item, i2, item2, im, vm) {
      item.showImgMore = null; // eslint-disable-line
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        const m = (media.gallery) ? media.gallery[0] : media;
        vm.variants[i].images[i2].media = m; // eslint-disable-line
      });
    },
    deleteImgV(i, item, i2, item2, im, vm) {
      vm.variants[i].images.splice(i2, 1); // eslint-disable-line 
    },
    deleteImg(i, item) {
      this.showImgMore = null;
      this.images.splice(i, 1);
    },
    editImg(i, item) {
      this.showImgMore = null;
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        this.images[i].media = media;
      });
    },
    addImg() {
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        if (!b) return;
        const m = (media.gallery) ? media.gallery : [media];
        const data = [];
        for (const item of m) { // eslint-disable-line
          data.push({ media: item });
        }
        this.images.push(...data);
      });
    },
    deleteTab(i) {
      this.selectTab(0, this.tabs[0]);
      this.tabs.splice(i, 1);
    },
    selectTab(i, item) {
      this.tabActive = i;
      this.tabs[i].content = '';
      setTimeout(() => {
        this.tabs[i].content = item.model;
      });
    },
    addTab() {
      this.$refs.formInputer.open({
        title: 'New Tab',
        placeholder: 'Tab title...',
      }, (b, v) => {
        if (!b) return;
        this.tabs.push({ title: v, model: '', content: '' });
        this.selectTab(this.tabs.length - 1, { model: '' });
      });
    },
    cancel() {
      if (this.section === 0) {
        this.close(false);
        return;
      }
      this.section -= 1;
      switch (this.section) {
        case 0:
          this.title = 'Product Data';
          break;
        case 1:
          this.title = 'Product Info';
          break;
        case 2:
          this.title = 'Product Description';
          this.tabs[0].content = '';
          setTimeout(() => {
            this.tabs[0].content = this.tabs[0].model;
          });
          break;
        case 3:
          this.title = 'Price & Variant';
          break;
        case 4:
          this.title = 'Product Dimension';
          break;
        default: break;
      }
    },
    async handleSubmit() {
      if (this.loading) return;
      if (this.section === 0) {
        if (!this.form.name.model || this.form.name.model === '') {
          this.form.name.error = true;
          return;
        }
        this.section = 1;
        this.title = 'Product Info';
      } else if (this.section === 1) {
        this.section = 2;
        this.title = 'Product Description';
        this.tabs[0].content = '';
        setTimeout(() => {
          this.tabs[0].content = this.tabs[0].model;
        });
      } else if (this.section === 2) {
        this.section = 3;
        this.title = 'Price & Variant';
      } else if (this.section === 3) {
        if ((!this.form.sku.model || this.form.sku.model === '')
          && !this.form.sku.auto) {
          this.form.sku.error = 'SKU Required';
          return;
        }
        this.loading = true;
        const editId = (this.d) ? this.d.id : null;
        this.$http.post(this.$config.uri('product/sku/check'), {
          id: editId,
          sku: this.form.sku.model,
        }).then((r) => {
          this.loading = false;
          if (r.data.status === 200) {
            this.form.sku.error = 'SKU Exist';
            return;
          }
          this.section = 4;
          this.title = 'Product Dimension';
        });
      } else {
        if (!this.form.weight.model) this.form.weight.model = 1;
        if (!this.form.length.model) this.form.length.model = 1;
        if (!this.form.width.model) this.form.width.model = 1;
        if (!this.form.height.model) this.form.height.model = 1;
        const formData = {
          name: this.form.name.model,
          category: this.form.category.model,
          edition: this.form.edition.model,
          warehouse: this.form.warehouse.model,
          description: this.tabs[0].model,
          minPurchase: this.form.minPurchase.model,
          inStock: this.form.inStock.model,
          sku: this.form.sku.model,
          skuAuto: this.form.sku.auto,
          sellPrice: this.form.sellPrice.model,
          discount: this.form.discount.model,
          discountType: this.form.discountType.model,
          dweight: this.form.weight.model,
          dlength: this.form.length.model,
          dwidth: this.form.width.model,
          dheight: this.form.height.model,
          preOrder: this.preOrder,
          preOrderDays: this.form.preOrderDays.model,
          images: this.images,
          info: this.info,
          tabs: this.tabs,
          variants: this.variantMaster,
        };
        if (this.d && this.d.id) formData.id = this.d.id;
        this.loading = true;
        this.$http.post(this.$config.uri('product/save'), formData).then((r) => {
          this.loading = false;
          if (r.data.status !== 200) {
            return;
          }
          this.close(true);
        });
      }
    },
    fieldChangedV(i, field) {
      this.variants[i][field].error = null;
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
  },
};
</script>

<style scoped lang="scss">
.variantCnt{
  .variantItem{
    position: relative;
    padding: 14px 20px 0;
    border-radius: 5px;
    border: #ddd 2px dashed;
    margin: 0 0 10px;
    h5{
      margin: 0 0 12px;
      font-size: 18px;
      font-weight: 500;
      border-bottom: #eee 1px solid;
      padding: 0 7px 10px;
    }
    .setAsDefault, .isDefault{
      position: absolute;
      right: 27px; top: 12px;
      color: #0067ff;
      font-weight: 600;
      cursor: pointer;
    }
    .isDefault{
      color: #444;
      img{
        float: left;
        height: 18px;
        margin-right: 8px;
      }
    }
  }
}

.deleteVariant{
  position: absolute;
  right: -8px; top: -8px;
  background-color: red;
  border-radius: 50%;
  width: 18px; height: 18px;
  background-image: url(../assets/close-white.png);
  background-size: 6px auto;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
  transition: all .3s ease;
  &.deleteTab{
    top: 2px; right: -14px;
  }
}
.fieldGroup.fg2c{
  position: relative;
  .deleteVariant{
    width: 36px; height: 36px;
    background-image: url(../assets/trash-black.png);
    background-size: 18px auto;
    right: -40px; top: 28px;
    background-color: transparent;
    box-shadow: none;
    opacity: .56;
    &:hover{
      opacity: .7;
      background-color: #ddd;
    }
  }
}

.addVariantCnt{
  // text-align: right;
}
.addVariant{
  white-space: nowrap;
  width: auto;
  color: #0e5dd2;
  opacity: 1;
  display: inline-block;
  cursor: pointer;
  border: #0e5dd2 1px solid;
  border-radius: 50px;
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
  position: relative;
  padding-left: 34px;
  margin-bottom: 20px;
  &:hover{
    background-color: #f5f5f5;
    box-shadow: 0 0 4px rgba(0,0,0,.2);
  }
  &:before{
    top: 0; left: 6px; bottom: 0;
    content: "";
    position: absolute;
    width: 20px;
    background-image: url(../assets/plus-circle.png);
    background-size: 20px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.fieldCnt.fc2{
  .fieldPrefix{
    left: 28px;
  }
  .fieldSuffix{
    right: 30px;
  }
}
.fieldCnt.fieldSku{
  .toggle{
    position: absolute;
    right: 10px; top: 30px;
    z-index: 3;
  }
}

.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    // backdrop-filter: saturate(180%) blur(20px);
    z-index: 1;
    opacity: 1;
  }
  .modalContent{
    position: absolute;
    background-color: #fff;
    z-index: 2;
    padding: 30px 80px;
    border-radius: 5px;
    margin-top: -20px;
    overflow: hidden;
    max-width: none;
    width: 600px;
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    .formCnt{
      margin: 0 -80px;
      padding: 10px 80px 40px;
      box-sizing: border-box;
      min-height: 340px;
      max-height: 78vh;
      overflow-y: auto;
      border-top: #eee 1px solid;
      .tabCnt{
        margin: -10px -80px 0;
        padding: 0 80px;
        .tab{
          width: auto;
          padding: 10px 0;
          background-color: #fff;
          margin-right: 30px;
          &:before{
            display: none;
          }
          &.addTab{
            border: #0e5dd2 1px solid;
            border-radius: 50px;
            padding: 0 14px;
            padding-left: 32px;
            font-weight: 500;
            height: 30px;
            color: #0e5dd2;
            line-height: 30px;
            margin-top: 5px;
            position: relative;
            &:after{
              display: none;
            }
            &:before{
              top: 5px; left: 5px; bottom: 0;
              content: "";
              position: absolute;
              display: block;
              opacity: 1;
              width: 20px; height: 20px;
              background-image: url(../assets/plus-circle.png);
              background-size: 20px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
          }
        }
      }
      .priceOk{
        position: relative;
        margin-top: -8px;
        .priceNav{
          position: absolute;
          top: 52px; width: 34px; height: 34px;
          border-radius: 50%;
          background-color: #fff;
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 9;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
          &.n{
            right: -17px;
            background-image: url(../assets/right-arrow.png);
          }
          &.p{
            background-image: url(../assets/left-arrow.png);
            left: -17px;
          }
        }
        .priceSc{
          overflow: hidden;
          padding-top: 10px;
          position: relative;
        }
      }
      .prizeCnt{
        display: flex;
        transition: all .3s ease;
        &.prize1{ margin-left: -130px; }
        &.prize2{ margin-left: calc(-130px * 2); }
        &.prize3{ margin-left: calc(-130px * 3); }
        &.prize4{ margin-left: calc(-130px * 4); }
        &.prize5{ margin-left: calc(-130px * 5); }
        &.prize6{ margin-left: calc(-130px * 6); }
        &.prize7{ margin-left: calc(-130px * 7); }
        &.prize8{ margin-left: calc(-130px * 8); }
        &.prize9{ margin-left: calc(-130px * 9); }
        &.prize10{ margin-left: calc(-130px * 10); }
        &.prize11{ margin-left: calc(-130px * 11); }
        &.prize12{ margin-left: calc(-130px * 12); }
        &.prize13{ margin-left: calc(-130px * 13); }
        &.prize14{ margin-left: calc(-130px * 14); }
        &.prize15{ margin-left: calc(-130px * 15); }
        &.prize16{ margin-left: calc(-130px * 16); }
        &.prize17{ margin-left: calc(-130px * 17); }
        &.prize18{ margin-left: calc(-130px * 18); }
        &.prize19{ margin-left: calc(-130px * 19); }
        &.prize20{ margin-left: calc(-130px * 20); }
        &.prize21{ margin-left: calc(-130px * 21); }
        &.prize22{ margin-left: calc(-130px * 22); }
        &.prize23{ margin-left: calc(-130px * 23); }
        &.prize24{ margin-left: calc(-130px * 24); }
        &.prize25{ margin-left: calc(-130px * 25); }
        &.prize26{ margin-left: calc(-130px * 26); }
        &.prize27{ margin-left: calc(-130px * 27); }
        &.prize28{ margin-left: calc(-130px * 28); }
        &.prize29{ margin-left: calc(-130px * 29); }
        &.prize30{ margin-left: calc(-130px * 30); }
        .prizeItem{
          margin: 0 10px 10px 0;
          h4{
            margin: 5px 0 0;
            font-size: 14px;
            text-align: center;
            font-weight: 600;
          }
          p{
            text-align: center;
            margin: 0;
            font-size: 10px;
            color: #767676;
          }
        }
      }
      .catImg{
        width: 120px; height: 120px;
        background-color: #eee;
        border-radius: 5px;
        margin-right: auto;
        position: relative;
        transition: background-color, box-shadow .3s ease;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        cursor: pointer;
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          opacity: .3;
          background-image: url(../assets/image-black.png);
          background-size: 46px auto;
          background-position: center;
          background-repeat: no-repeat;
          transition: all .3s ease;
        }
        .moreMenu{
          position: absolute;
          background-color: #fff;
          padding: 10px 0;
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
          border-radius: 3px;
          right: 6px; top: 6px;
          li{
            list-style: none;
            padding: 4px 16px;
            font-size: 15px;
            white-space: nowrap;
            transition: all .3s ease;
            cursor: pointer;
            &.red{
              color: red;
            }
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
        .more{
          background-color: #fff;
          width: 30px; height: 30px;
          position: absolute;
          right: -5px; top: -4px;
          border-radius: 50%;
          background-image: url(../assets/more.png);
          background-repeat: no-repeat;
          background-size: 12px auto;
          background-position: center;
          transition: opacity .3s ease;
          transition: all .3s ease;
          cursor: pointer;
          box-shadow: 2px 2px 4px rgba(0,0,0,.1);
          &:hover{
            opacity: 1;
            box-shadow: 2px 2px 6px rgba(0,0,0,.2);
          }
        }
        &.hasImg{
          &:before{
            display: none;
          }
        }
        &:hover{
          background-color: #e5e5e5;
          // box-shadow: 2px 2px 4px rgba(0,0,0,.2);
          &:before{
            opacity: .4;
          }
        }
        &.addPrize{
          font-size: 13px;
          font-weight: 600;
          color: #999;
          text-align: center;
          padding: 24px 0 0;
          text-transform: uppercase;
          cursor: pointer;
          span{
            display: block;
            font-size: 36px;
            font-weight: 400;
            margin: 0 0 -4px;
            img{
              height: 30px;
              opacity: .3;
            }
          }
          &:before{
            display: none;
          }
        }
      }
    }
    h4{
      margin: 0 0 10px;
      font-size: 24px;
      font-weight: normal;
      color: #444;
      text-align: left;
    }
    p{
      margin: 0;
      color: #767676;
    }
    .modalAction{
      position: absolute;
      left: 0; right: 0; bottom: 0;
      padding: 12px 30px;
      z-index: 991;
      text-align: right;
      background-color: #fff;
      border-top: #eee 1px solid;
      &.textLeft{
        text-align: left;
      }
      .btn{
        margin-left: 10px;
        position: relative;
        transition: background-color, box-shadow .3s ease;
      }
    }
  }
}
</style>
